import React, { useContext } from 'react';
import { GoX } from 'react-icons/go';

import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';
import { ClearFiltersText } from 'src/pages/CatalogPage/components/FilterMenu/ClearFilters/ClearFilters.style';
import { TextButton } from '@riac/design-system';
import { ISearchInput } from 'src/pages/CatalogPage/CatalogPage.i';

export interface IClearFiltersProps {
  searchInput: ISearchInput;
}

export const ClearFilters = ({ searchInput }:IClearFiltersProps) => {
  const { auctionId, gotoAddress } = useContext(CatalogContext);
  const address = `/catalog/${auctionId}/`;
  const ignoreKeys = ['pageNumber', 'perPage', 'sortBy'];
  let hasFilters = false;

  for(const key in searchInput) {
    if(ignoreKeys.indexOf(key) >= 0) {
      continue;
    }
    if(searchInput.hasOwnProperty(key) && searchInput[key]) {
      hasFilters = true;
    }
  }

  return (
    <ClearFiltersText>
      <TextButton to={address} onPress={() => {
        gotoAddress(address);
      }}>
        {hasFilters
          && <><GoX /> Clear Filters</>
        }
      </TextButton>
    </ClearFiltersText>
  );
};
